/**
 * TrainingValidityStatusChip Component
 * Visual indicator for training validity status
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  CheckCircle as ValidIcon,
  Warning as WarningIcon,
  Error as ExpiredIcon,
} from '@mui/icons-material';
import {
  TrainingValidityStatus,
  TrainingValidityStatusLabels,
  TrainingValidityStatusColors,
  TrainingValidityStatusChipProps,
} from '../../../types/training';

export const TrainingValidityStatusChip: React.FC<TrainingValidityStatusChipProps> = ({
  status,
  daysUntilExpiry,
  size = 'small',
}) => {
  const getIcon = () => {
    switch (status) {
      case TrainingValidityStatus.VALID:
        return <ValidIcon fontSize="small" />;
      case TrainingValidityStatus.WARNING:
        return <WarningIcon fontSize="small" />;
      case TrainingValidityStatus.EXPIRED:
        return <ExpiredIcon fontSize="small" />;
      default:
        return undefined;
    }
  };

  const getTooltipText = () => {
    if (daysUntilExpiry === undefined) {
      return TrainingValidityStatusLabels[status];
    }

    if (daysUntilExpiry < 0) {
      return `Vencido há ${Math.abs(daysUntilExpiry)} dias`;
    }

    if (daysUntilExpiry === 0) {
      return 'Vence hoje';
    }

    if (daysUntilExpiry === 1) {
      return 'Vence amanhã';
    }

    return `Vence em ${daysUntilExpiry} dias`;
  };

  return (
    <Tooltip title={getTooltipText()}>
      <Chip
        icon={getIcon()}
        label={TrainingValidityStatusLabels[status]}
        color={TrainingValidityStatusColors[status]}
        size={size}
        variant="filled"
      />
    </Tooltip>
  );
};

export default TrainingValidityStatusChip;
